// extracted by mini-css-extract-plugin
module.exports =  {"root":"fqU0EhqFGu8clPpbvOac","anonymous":"NWf8ReUQ3p9Nnqv9P39Q"};